import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { make } from 'vuex-pathify';
import faq from '../services/faq';
var state = {
  carregando: false,
  erro: false,
  todas: []
};
var mutations = make.mutations(state);
var actions = {
  carregar: function carregar(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var commit, rootState, resultado, faqs, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit, rootState = _ref.rootState;
            console.debug('Carregando FAQs');
            commit('carregando', true);
            _context.p = 1;
            _context.n = 2;
            return faq.listar({
              limite: 1000,
              ordem: 'ordem',
              chave_empresa: rootState.auth.empresa.chave
            });
          case 2:
            resultado = _context.v;
            faqs = agruparFaqs(resultado['data']['objects']);
            commit('erro', false);
            commit('todas', faqs);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('Não foi possível carregar as FAQs', _t);
            commit('erro', true);
          case 4:
            _context.p = 4;
            commit('carregando', false);
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }))();
  }
};
var getters = {
  carregando: function carregando(state) {
    return state.carregando;
  },
  erro: function erro(state) {
    return state.erro;
  },
  todas: function todas(state) {
    return state.todas;
  }
};
function agruparFaqs(faqs) {
  var faqsAgrupadas = [];
  if (!faqs) {
    return [];
  }
  var categorias = _toConsumableArray(new Set(faqs.map(function (faq) {
    return faq.categoria;
  })));
  faqsAgrupadas = categorias.map(function (categoria) {
    return {
      categoria: categoria,
      faqs: faqs.filter(function (faq) {
        return faq.categoria == categoria;
      })
    };
  });
  return faqsAgrupadas;
}
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};